import React, { useContext, useEffect, useRef, useState } from "react";
import "./Remote.css";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";

import { Link, useParams } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";
import { Context } from "../../../context/Context";

const InputStatus = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  commands,
  setCommands,
}) => {
  const {
    equipmentButtons,
    devices,
    equipments,
    addScenarioCommandDetail,
    scenarioCommandDetail,
    scenarioCommands,
    setScenarioCommands,
  } = useContext(Context);
  const [buttons, setButtons] = useState([]);
  const [buttonStates, setButtonStates] = useState({});
  const [update, setUpdate] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  useEffect(() => {
    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id),
    );
  }, [update, equipmentButtons, equipment_id]);

  const handleClickButton = (button, icon) => {
    setSelectedButton({
      id: button.id,
      icon,
      state:
        selectedButton && selectedButton.id == button.id
          ? selectedButton.state
            ? 0
            : 1
          : 1,
    });
  };

  const findButtonState = (button) => {
    let device = devices.find((d) => d.id == button.device_id);
    let buttonState;
    if (device.type == 9 || device.type == 5) {
      buttonState =
        buttonStates?.[device.id]?.[button.digit - 12] == undefined
          ? 2
          : buttonStates?.[device.id]?.[button.digit - 12] == 0
            ? 0
            : buttonStates?.[device.id]?.[button.digit - 12] == 1
              ? 1
              : null;
    } else {
      buttonState =
        buttonStates?.[device.id]?.[button.digit] == undefined
          ? 2
          : buttonStates?.[device.id]?.[button.digit] == 0
            ? 0
            : buttonStates?.[device.id]?.[button.digit] == 1
              ? 1
              : null;
    }

    return buttonState;
  };
  
  const handleSubmit = () => {
    const button = buttons.find((btn) => btn.id == selectedButton.id);
    const btnDevice = devices.find((d) => d.id == button.device_id);
    let data1 = button.digit;
    let data2 = selectedButton.state;
    let data3 = null;
    let data4 = null;
    let data5 = null;
    let data6 = null;
    let data7 = null;
    let data8 = null;
    let data9 = null;
    let data10 = null;
    let data11 = null;
    if (btnDevice.type == 5) {
      data3 = 0;
      data4 = 0;
    } else if (btnDevice.type == 4 || btnDevice.type == 9) {
      data3 = 0;
      data4 = 0;
      data5 = 0;
      data6 = 0;
      data7 = 0;
      data8 = 0;
      data9 = 0;
      data10 = 0;
      data11 = 0;
    } else if (btnDevice.type == 3) {
      data1 = button.digit;
      data3 = 0;
      data4 = 0;
      data5 = 0;
      data6 = 0;
    }
    if (scenarioCommandDetail.id) {
      setCommands((prevCommands) =>
        prevCommands.map((command) =>
          command.id == scenarioCommandDetail.id
            ? {
                ...command,
                device_id: button.device_id,
                time: scenarioCommandDetail.time,
                data1: data1,
                data2: data2,
                data3: data3,
                data4: data4,
                data5: data5,
                data6: data6,
                data7: data7,
                data8: data8,
                data9: data9,
                data10: data10,
                data11: data11,
                command_name: String(button.name),
                icon: button.icon ?? 1,
              }
            : command,
        ),
      );
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    } else {
      setCommands((prev) => [
        ...prev,
        {
          id: new Date().getTime(),
          scenario_id: addScenarioCommandDetail.scenario_id,
          data1: data1,
          data2: data2,
          data3: data3,
          data4: data4,
          data5: data5,
          data6: data6,
          data7: data7,
          data8: data8,
          data9: data9,
          data10: data10,
          data11: data11,
          command_name: String(button.name),
          icon: selectedButton.icon,
          device_id: button.device_id,
          time: 500,
        },
      ]);
      setSelectedButton(null);
      closeSelectEquipmentRef.current.click();
      closeSelectOutputEquipmentRef.current.click();
    }
  };

  const getDeviceForButton = (button) => {
    return devices.find((d) => d.id == button.device_id);
  };

  const renderSubName = (button) => {
    const device = getDeviceForButton(button);
    if (!device) return '';
    
    if (device.type == 3) {
      return 's' + (Number(button.digit) - 64);
    } else {
      if (button.digit >= 89) {
        return `s${Number(button.digit) - 88}`;
      } else {
        return `i${Number(button.digit) - 64}`;
      }
    }
  };

  const renderButtons = () => {
    return buttons.map((button) => {
      let device = devices.find((d) => d.id == button.device_id);
      if (!device) {
        return;
      }
      let iconPath = "/assets/img/custom-equipment-button/19.png";
      let iconId = 19;
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon,
        );
        iconPath = buttonIcon.path;
        iconId = buttonIcon.id;
      }

      let buttonState = findButtonState(button);

      return (
        <div
          className="remote"
          key={button.id}
          onClick={() => handleClickButton(button, iconId)}
        >
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div
            className={
              selectedButton && selectedButton.id == button.id
                ? selectedButton.state
                  ? "status-part bg-success"
                  : "status-part bg-danger"
                : "status-part"
            }
          ></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0" style={{ fontSize: "11px" }}>
              {renderSubName(button)}
              -S/{devices.find((d) => d.id == button.device_id).serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className="card h-100"
      // style={{ backgroundColor: "#fff0", boxShadow: "none" }}
       style={{backgroundColor: 'transparent', boxShadow: 'unset'}}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: "1", top: "0" }}
      >
        <h5>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <button
          type="button"
          className="btn btn-icon btn-success-app"
          onClick={handleSubmit}
        >
          <span className="tf-icons bx bx-check"></span>
        </button>
      </div>
      <div className="card-body scrollbar">
        <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
      </div>
    </div>
  );
};

export default React.memo(InputStatus);